import React from "react";
import {
  RazonFinancieraSubItem4_1,
} from "./RazonFinancieraSubItem";

export const RotacionInventarioItem = ({ data, sucursales }) => {
    console.log('entro rotacion')
  const rotacioninventario = data?.rotacioninventario?.inventario ?? 0
  const GetIndicador = (valor, minino, medio) => {
    if (valor <= minino) return "flag-red";
    else if (valor <= medio) return "flag-yellow";
    else return "flag-green";
  };
  const getMedida = (indicador) => {
    if (indicador === "%") return "porcentaje";
    if (indicador === "x") return "numero-vueltas";
  };

  const convertGuiaNumero = (guia) => {
    if (!guia) return 0;
    const value = guia.replace(/[^\d\.x]/g, '');
    if (value.includes('x')) {
      return parseFloat(value.replace('x', ''));
    } else {
      return parseFloat(value);
    }
  };

  // console.log(rotacionActivosIndicador)
  // console.log (getMedida(rotacionActivosIndicador))

  return (
    <>
      <div className="dashboard-financiero-razones-financieras-proyecciones2">

        {/* <RazonFinancieraSubItem4_1
          titulo="Factor de Absorción"
          valor={factorAbsorcion}
          guia={convertGuiaNumero(factorAbsorcionGuia)}
          medida={getMedida(factorAbsorcionIndicador)}
          modal={"FactorAbsorcion"}
          sucursales={sucursales}
        />
        <RazonFinancieraSubItem4_1
          titulo="Rotación de Activos"
          valor={rotacionActivos}
          guia={convertGuiaNumero(rotacionActivosGuia)}
          medida={getMedida(rotacionActivosIndicador)}
          modal={"RotacionInventario"}
        />
        <RazonFinancieraSubItem4_1
          titulo="Capital a Activos"
          valor={capitalActivos}
          guia={convertGuiaNumero(capitalActivosGuia)}
          medida={getMedida(capitalActivosIndicador)}
        // modal={"CapitalActivos"}
        />
        <RazonFinancieraSubItem4_2
          titulo="Cobertura de Intereses"
          valor={coberturaIntereses}
          guia={convertGuiaNumero(coberturaInteresesGuia)}
          medida={getMedida(coberturaInteresesIndicador)}
        // modal={"CoberturaIntereses"}
        /> */}
        <RazonFinancieraSubItem4_1
          titulo="Rotación Inventario"
          valor={rotacioninventario}
          guia={0}
          medida={"numero-vueltas"}
          modal={"InventarioRotacionMainScreen"}
          sucursales={sucursales}
        />
      </div>

      {/* <div className="dashboard-financiero-razones-financieras-proyecciones2">
        <RazonFinancieraSubItem4_1
          titulo="Proyecciones Ventas"
          valor={0}
          guia={0}
          medida={"numero-vueltas"}
          modal={"ProyeccionesScreen"}
          sucursales={sucursales}
        />
        <RazonFinancieraSubItem4_1
          titulo="Proyecciones Gastos"
          valor={0}
          guia={0}
          medida={"numero-vueltas"}
          modal={"ProyeccionesGastosScreen"}
          sucursales={sucursales}
        />

      </div> */}
    </>
  );
};
